/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';

export const RedirectEmptyRoutePage: React.FC = (): JSX.Element => {
  const location = useLocation();
  console.log('location in redirect empty route page', location);

  return (
    <Redirect
      to={{
        pathname: '/'
      }}
    />
  );
};

export default RedirectEmptyRoutePage;
